import React from 'react';
import { Typography, Paper, Box, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FlareIcon from '@mui/icons-material/Flare';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import PaidIcon from '@mui/icons-material/Paid';
import GroupIcon from '@mui/icons-material/Group';
import HistoryIcon from '@mui/icons-material/History';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptIcon from '@mui/icons-material/Receipt';

import Header from '../panel/Header';

const DashboardCard = ({ title, marathiTitle, icon, color, link }) => (
  <Grid>
    <Link to={link} style={{ textDecoration: 'none' }}>
      <Paper
        elevation={4}
        sx={{
          borderRadius: 2,
          p: 2,
          background: color,
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: 120,
          transition: 'transform 0.3s, box-shadow 0.3s',
          cursor: 'pointer',
          textAlign: 'center',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 6px 14px rgba(0,0,0,0.3)',
          },
        }}
      >
        <Box
          sx={{
            fontSize: 36,
            mb: 1,
            backgroundColor: 'rgba(255,255,255,0.15)',
            borderRadius: 2,
            width: 60,
            height: 60,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {icon}
        </Box>
        <Typography variant="subtitle1" fontWeight="bold">
          {title}
        </Typography>
        <Typography variant="caption" sx={{ mt: 0.5 }}>
          {marathiTitle}
        </Typography>
      </Paper>
    </Link>
  </Grid>
);

const Home = () => {
  return (
    <Box>
      <Header />

      <Typography variant="h5" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
        Shop & Sales Sections / दुकान व विक्री विभाग
      </Typography>

      <div className="row">
        <div className="col-sm-2 mt-3">
          <DashboardCard
            title="Shop Section"
            marathiTitle="दुकान विभाग"
            icon={<ShoppingCartIcon fontSize="inherit" />}
            color="#3f51b5"
            link="/category/shop"
          />
        </div>
        <div className="col-sm-2 mt-3">
          <DashboardCard
            title="Wholesaler Section"
            marathiTitle="घाऊक विभाग"
            icon={<LocalShippingIcon fontSize="inherit" />}
            color="#009688"
            link="/category/wholesaler"
          />
        </div>
        <div className="col-sm-2 mt-3">
          <DashboardCard
            title="Mashal Section"
            marathiTitle="मशाल विभाग"
            icon={<FlareIcon fontSize="inherit" />}
            color="#673ab7"
            link="/category/mashal"
          />
        </div>
        <div className="col-sm-2 mt-3">
          <DashboardCard
            title="Finance Section"
            marathiTitle="आर्थिक विभाग"
            icon={<MonetizationOnIcon fontSize="inherit" />}
            color="#ff9800"
            link="/category/finance"
          />
        </div>
        <div className="col-sm-2 mt-3">
          <DashboardCard
            title="Takkevari Section"
            marathiTitle="टक्केवारी विभाग"
            icon={<ShowChartIcon fontSize="inherit" />}
            color="#4caf50"
            link="/category/takkevari"
          />
        </div>
        <div className="col-sm-2 mt-3">
          <DashboardCard
            title="Payroll Section"
            marathiTitle="पगार विभाग"
            icon={<PaidIcon fontSize="inherit" />}
            color="#f44336"
            link="/category/payroll"
          />
        </div>
        <div className="col-sm-2 mt-3">
          <DashboardCard
            title="Outstanding Section"
            marathiTitle="उसणे  विभाग"
            icon={<PaidIcon fontSize="inherit" />}
            color="#c16503ff"
            link="/category/udhari"
          />
        </div>
      </div>

      <Typography variant="h5" sx={{ mt: 4, mb: 1, fontWeight: 'bold' }}>
        Management & Reports / व्यवस्थापन व अहवाल
      </Typography>

      <Grid container className="row">
        <div className="col-sm-2 mt-3">
          <DashboardCard
            title="Users Mgmt"
            marathiTitle="वापरकर्ता व्यवस्थापन"
            icon={<GroupIcon />}
            color="#b5a10b"
            link="/users-mgmt"
          />
        </div>
        <div className="col-sm-2 mt-3">
          <DashboardCard
            title="Login History"
            marathiTitle="लॉगिन इतिहास"
            icon={<HistoryIcon />}
            color="#795548"
            link="/login-history"
          />
        </div>
        <div className="col-sm-2 mt-3">
          <DashboardCard
            title="All Income Report"
            marathiTitle="संपूर्ण उत्पन्न अहवाल"
            icon={<AccountBalanceWalletIcon />}
            color="#1976d2"
            link="/income-report"
          />
        </div>
        <div className="col-sm-2 mt-3">
          <DashboardCard
            title="All Expense Report"
            marathiTitle="संपूर्ण खर्च अहवाल"
            icon={<ReceiptIcon />}
            color="#9c27b0"
            link="/expense-report"
          />
        </div>
      </Grid>
    </Box>
  );
};

export default Home;
